module.exports = __webpack_public_path__ + "static/media/notification.e67cdd68.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/mp3/notification.mp3
// module id = 170
// module chunks = 0